import { atom } from "jotai";

const itemNamesAtom = atom<Record<string, string>>()

export default itemNamesAtom
